var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Instagram_svg__a",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 62 2 48.568 2 32 2 15.43 15.431 2 32 2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Instagram_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Instagram_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.923 8.998a4.929 4.929 0 01-4.925 4.924 4.927 4.927 0 01-4.92-4.924c0-.65.13-1.276.361-1.846H1.753v7.37c0 .954.771 1.723 1.724 1.723H14.52c.953 0 1.725-.77 1.725-1.722v-7.37h-2.686c.23.569.364 1.194.364 1.845zM18 7.152v7.37A3.481 3.481 0 0114.52 18H3.477A3.48 3.48 0 010 14.523V3.48C0 1.56 1.56 0 3.477 0H14.52C16.44 0 18 1.56 18 3.48v3.672zm-2.082-2.03v-3.05h-.398l-2.655.01.012 3.05 3.04-.01zm-6.92 7.045a3.171 3.171 0 003.17-3.169 3.17 3.17 0 00-3.169-3.166c-1.056 0-1.993.52-2.568 1.32a3.16 3.16 0 00-.6 1.846 3.171 3.171 0 003.167 3.169z",
    fill: "currentColor",
    mask: "url(#Instagram_svg__b)"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    cx: 32,
    cy: 32,
    r: 17.75
  }))));
};
export default SvgInstagram;